<i18n src="../i18n/store-locator.json" />

<template>
  <div class="store-locator-large">
    <div class="store-locator-large__stores">
      <div class="store-locator-large__stores-header">
        <MainTitle :page-title="pageTitle" yellow-backdrop></MainTitle>
        <StoreLocatorAroundMe @click="setCurrentPosition" />
      </div>

      <transition-group
        class="store-locator-large__stores-list"
        name="store-locator-large__stores-item-"
        tag="ul"
      >
        <li
          v-for="store in orderedStores"
          :key="store.id"
          class="store-locator-large__stores-item"
        >
          <StoreLocatorStoreCard :position="currentPosition" :store="store" />
        </li>
      </transition-group>
    </div>

    <StoreLocatorMap
      :offset-x="offsetX"
      :position="currentPosition"
      :selected-store="currentStore"
      :stores="stores"
      :default-map-bounds="defaultMapBounds"
      :default-map-position="defaultMapPosition"
      :defaultMapPosition="defaultMapPosition"
      @update:store="setCurrentStore"
    />
  </div>
</template>

<script>
import StoreLocator from '../mixins/StoreLocator';

export default {
  name: 'StoreLocatorLarge',
  mixins: [StoreLocator],
  computed: {
    /**
     * @return {number}
     */
    offsetX() {
      return window.innerWidth / 4;
    },
  },
};
</script>
